import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, columns }) => ({
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
        flexDirection: `${columns === 2 ? 'row' : 'column'}`,
        alignItems: `${columns === 2 ? 'flex-end' : 'flex-start'}`
    },
    '& .contactsItem': {
        '&-image': {
            position: 'relative',
            width: '100%',
            overflow: 'hidden',
            borderRadius: toRem(4),

            [theme.breakpoints.up('lg')]: {
                ...(columns === 2 && {
                    width: `calc(54.83% - ${toRem(36)})`,
                    margin: `0 ${toRem(36)} 0 0`
                })
            },
            [theme.breakpoints.down('520')]: {
                maxWidth: toRem(150)
            }
        },
        '&-contact': {
            width: '100%',
            padding: toRems([20, 20, 0, 20]),
            fontSize: toRem(14),
            lineHeight: '170%',
            color: theme.colors.text.default,
            [theme.breakpoints.up('520')]: {
                padding: toRems([20, 0, 0, 0])
            },
            [theme.breakpoints.up('lg')]: {
                ...(columns === 2 && {
                    padding: 0,
                    width: '45.16%'
                })
            },
            '&Wrapper': {
                display: 'flex',
                alignItems: 'center',
                margin: toRems([0, 0, 6, 0]),

                svg: {
                    display: 'flex',
                    marginRight: toRem(5)
                }
            },
            '&Name': {
                margin: toRems([20, 0, 6, 0]),
                fontSize: toRem(20),
                lineHeight: 1.8,
                fontWeight: theme.typography.fontWeight.medium,
                color: theme.colors.text.goldDark
            },
            '&Position': {
                margin: toRems([5, 0, 0, 0]),
                fontWeight: theme.typography.fontWeight.medium
            },
            '&Speaking': {
                margin: toRems([0, 0, 20, 0])
            },
            '&Phone': {
                lineHeight: 1
            },
            '&Email': {
                lineHeight: 1
            },
            '&Button': {
                marginTop: toRem(30),

                '& a': {
                    padding: toRems([8, 16, 8, 10])
                },

                '& span': {
                    fontSize: toRem(14),
                    fontWeight: 600
                },

                svg: {
                    marginRight: toRem(5)
                }
            },
            '& p': {
                margin: 0,
                fontSize: 'inherit',
                lineHeight: 'inherit'
            }
        }
    }
})

export default style
